import React from 'react';
import AddressForm from '../Forms/AddressForm';
import Loading from '../Loading/Loading';

export default function AddressNewModal(props) {
	const {
		setNewAddressFormOpen,
		setShowEdit,
		updateLoading,
		address,
		setUpdateLoading,
		postNewAddress,
		handleAddressInput,
	} = props || {};
	return (
		<div className='mainModal'>
			<AddressForm address={address} handleAddressInput={handleAddressInput} required={true} />
			{!updateLoading ? (
				<div className='addressButtons'>
					<div>
						<input
							type='button'
							className='functionalButtonPrimary'
							onClick={() => {
								postNewAddress();
								setUpdateLoading(true);
							}}
							defaultValue='Save new address'
						/>
					</div>
					<div className='marginTop-10'>
						<input
							type='button'
							className='functionalButtonSecondary'
							onClick={() => {
								setNewAddressFormOpen(false);
								setShowEdit(false);
							}}
							defaultValue='Cancel'
						/>
					</div>
				</div>
			) : (
				<>
					<Loading type='circle' />
				</>
			)}
		</div>
	);
}
